export default {
    values: {
        critical: 'critical',
        Critical: 'Critical',
        CRITITAL: 'CRITITAL',
        'non-critical': 'non-critical',
        'Non-Critical': 'Non-Critical',
        'NON-CRITICAL': 'NON-CRITICAL',
        'activities or systems': 'activities or systems',
        'Activities or Systems': 'Activities or Systems',
        'ACTIVITIES OR SYSTEMS': 'ACTIVITIES OR SYSTEMS',
        'barrier type': 'barrier type',
        'Barrier Type': 'Barrier Type',
        'BARRIER TYPE': 'BARRIER TYPE',
        criticality: 'criticality',
        Criticality: 'Criticality',
        CRITICALITY: 'CRITICALITY',
        process: 'process',
        Process: 'Process',
        PROCESS: 'PROCESS',
        'initial frequency': 'initial frequency',
        'Initial Frequency': 'Initial Frequency',
        'INITIAL FREQUENCY': 'INITIAL FREQUENCY',
        'current frequency': 'current frequency',
        'Current Frequency': 'Current Frequency',
        'CURRENT FREQUENCY': 'CURRENT FREQUENCY',
        human: 'human',
        Human: 'Human',
        HUMAN: 'HUMAN',
        physical: 'physical',
        Physical: 'Physical',
        PHYSICAL: 'PHYSICAL',
        responsible: 'responsible',
        Responsible: 'Responsible',
        RESPONSIBLE: 'RESPONSIBLE',
        frequency: 'frequency',
        Frequency: 'Frequency',
        FREQUENCY: 'FREQUENCY',
        consequences: 'consequences',
        Consequences: 'Consequences',
        CONSEQUENCIES: 'CONSEQUENCIES',
        threats: 'Threats',
        Threats: 'Threats',
        THREATS: 'THREATS',
        Crítical: 'Crítical',
        'I don\'nt criticize': 'I don\'nt criticize',
        manager: 'manager',
        Manager: 'Manager',
        MANAGER: 'MANAGER',
        barriers: 'barriers',
        Barriers: 'Barriers',
        BARRIERS: 'BARRIERS',
        active: 'active',
        Active: 'Active',
        ACTIVE: 'ACTIVE',
        degraded: 'degraded',
        Degraded: 'Degraded',
        DEGRADED: 'DEGRADED',
        emergengy: 'emergengy',
        EMERGENGY: 'EMERGENGY',
        Emergency: 'Emergency',
        maritime: 'maritime',
        Maritime: 'Maritime',
        MARITIME: 'MARITIME',
        operation: 'operation',
        Operation: 'Operation',
        OPERATION: 'OPERATION',
        drilling: 'drilling',
        Drilling: 'Drilling',
        DRILLING: 'DRILLING',
        'active barriers': 'active barriers',
        'Active barriers': 'active barriers',
        'ACTIVE BARRIER': 'ACTIVE BARRIER',
        'ACTIVE BARRIERS': 'ACTIVE BARRIERS',
        'degraded barriers': 'degraded barriers',
        'Degraded barriers': 'Degraded barriers',
        'DEGRADED BARRIERS': 'DEGRADED BARRIERS',
        'DEGRADED BARRIER': 'DEGRADED BARRIER',
        'bowties with': 'bowties with',
        'Bowties with': 'Bowties with',
        'bowties with degraded barriers': 'bowties with degraded barriers',
        'Bowties with degraded barriers': 'Bowties with degraded barriers',
        mitigation: 'mitigation',
        Mitigation: 'Mitigation',
        MITIGATION: 'MITIGATION',
        prevention: 'prevention',
        Prevention: 'Prevention',
        PREVENTION: 'PREVENTION',
        intolerable: 'intolerable',
        Intolerable: 'Intolerable',
        INTOLERABLE: 'INTOLERABLE',
        'widely acceptable': 'widely acceptable',
        'Widely Acceptable': 'Widely Acceptable',
        'WIDELY ACCEPTABLE': 'WIDELY ACCEPTABLE',
        tolerable: 'tolerable',
        Tolerable: 'Tolerable',
        TOLERABLE: 'TOLERABLE',
    }
}